// String for the BNCC product landing page.

// Pro Tip: if you're searching for text to find out where something is
// rendered, consider using React DevTools instead.

import type {Images, Strings} from "./types.ts";

const strings: Strings = {
    ctaAccessHere: "Acesse aqui",

    ctaGetStarted: "Entre em contato",

    title: "Conteúdos 100% gratuitos e alinhados à BNCC para você utilizar com seus alunos.",

    whatIsIt: "Khan Academy + BNCC",

    whatIsItDescription:
        "A Khan Academy possui conteúdos de Matemática, Ciências e Língua Portuguesa alinhados à BNCC do Ensino Fundamental. Encontre exercícios, vídeos e artigos e comece a usar com seus alunos!",

    learnWithYourStudents: "Aprenda a usar a Khan Academy com seus alunos!",

    learnWithYourStudentsDescription:
        "Com a Formação Inicial para Professores você vai explorar as ferramentas para professores, ver exemplos reais de uso na sala de aula e ganhar um certificado de conclusão do curso!",

    learningAreas: [
        [
            "Matemática",
            "https://pt.khanacademy.org/math/brazil-math-grades",
            "Confira Matemática",
        ],
        [
            "Ciências",
            "https://pt.khanacademy.org/science/ciencias-por-ano",
            "Confira Ciências",
        ],
        [
            "Português",
            "https://pt.khanacademy.org/humanities/portugues-por-ano-bncc-ef",
            "Confira Português ",
        ],
    ],

    partnership: "Parceria com Secretarias de Educação",

    partnershipDescription:
        "A Khan Academy quer ser uma ferramenta de apoio na sua rede de ensino. Hoje contamos com mais de 50 secretarias parceiras e a sua pode ser a próxima! Entre em contato e saiba mais.",

    ctaLearnMore: "Saiba mais",

    trainingCta: "Confira a Formação Inicial",

    htmlTitle: "Khan Academy Brasil",

    resourcesLink:
        "https://pt.khanacademy.org/khan-for-educators/khan-academy-para-educadores/bncc-khan",

    partnershipLink: "https://khanacademy.typeform.com/to/L2yRyc",
    signupUrl: "https://pt.khanacademy.org/signup?isteacher=1",
    khanForEducatorsUrl: "https://pt.khanacademy.org/khan-for-educators",
};

export const images: Images = {
    hero: "/images/bncc/hero-bncc.png",
    map: "images/bncc/bncc-brazil-map.png",
    learn: "images/bncc/certificate-bncc.png",
    footer: "/images/bncc/teacher-collage-bncc.png",
    learningAreas: [
        "/images/bncc/math-icon-bncc.png",
        "/images/bncc/science-icon-bncc.png",
        "/images/bncc/portuguese-icon-bncc.png",
    ],
};

export default strings;
